import { useBulkActionContext } from '@user/components/xGrid'
import { useSelector } from 'react-redux'
import { type ILead, selectAllLeads } from '@user/store/lead'
import { ENTITY_TYPES } from '@sales-center/common'
import {
  type IOpportunity,
  selectAllOpportunities,
} from '@user/store/opportunity'
import {
  OwnerMenuItem,
  useGetOwnerList,
} from '@user/store/salesTeam/hooks/useGetOwnerList'

type Props = {
  entityType: ENTITY_TYPES
}

export function useData(props: Props) {
  const { entityType } = props
  const { selectedRows } = useBulkActionContext()
  const quantity: 'bulk' | 'single' =
    selectedRows?.length > 1 ? 'bulk' : 'single'
  const leads = useSelector(selectAllLeads)
  const opps = useSelector(selectAllOpportunities)
  const entityId = selectedRows[0]
  const entity = (
    (entityType === ENTITY_TYPES.Lead ? leads : opps) as { id: number }[]
  ).find((entity: ILead | IOpportunity) => entity.id === entityId) as {
    salesTeamId: number
    assignee: { id: string }
    id: number
  }

  const salesTeamId = entity?.salesTeamId || 0

  const ownerList: OwnerMenuItem[] = useGetOwnerList(
    entityType,
    +salesTeamId,
    false,
  )

  const ownerId =
    entity?.assignee.id &&
    entity?.assignee.id != '00000000-0000-0000-0000-000000000000'
      ? entity.assignee.id
      : 'unassigned'

  return {
    quantity,
    salesTeamId,
    ownerId,
    owners: ownerList,
  }
}
